/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ROUTES } from "../../../../shared";
import { useStyles } from "../../styles";
import SharedFilters from "../SharedFilters";

const VehicleFilters = () => {
  const { filtersMainBlock } = useStyles({});

  return (
    <div css={css(filtersMainBlock)} data-testid="vehicle-filters">
      <SharedFilters route={ROUTES.Vehicles} translateStatus="General" />
    </div>
  );
};

export default VehicleFilters;
